import React from 'react';

const faqs = [
  {
    category: '🧹 General FAQs',
    items: [
      {
        question: '1. How to use the Cleaner app?',
        answer:
          'Cleaner app helps you to clean junk files, optimize battery, keep the phone running smoothly with smart tools, manage storage, and more.',
      },
      {
        question: '2. Does this app slow down my phone?',
        answer:
          'No, the app is designed to improve the phone\'s performance and speed.',
      },
      {
        question: '3. Is the Cleaner app safe to use?',
        answer:
          'Yes, it is safe to use as your data stays private. The app only accesses files for cleaning and optimization features.',
      },
    ],
  },
  {
    category: '🔒 Privacy & Security FAQs',
    items: [
      {
        question: '4. How to use the App Lock?',
        answer:
          'You can lock the selected installed apps, using PIN to maintain privacy.',
      },
      {
        question: '5. What is WhatsApp Cleaner and will deleting files affect my chats?',
        answer:
          'You can easily find and remove your unwanted WhatsApp media like large files, images, and videos, while your chats remain safe.',
      },
    ],
  },
  {
    category: '📁 File Management FAQs',
    items: [
      {
        question: '6. How to transfer files with the Cleaner app?',
        answer:
          'You can share files, photos, videos from one device to another without using mobile data.',
      },
    ],
  },
  {
    category: '📱 App Management FAQs',
    items: [
      {
        question: '7. How does GoCleanr help in easy management?',
        answer:
          'You can quickly find apps using smart filters, sort, and search options, which makes app management fast.',
      },
      {
        question: '9. What does App Overview do?',
        answer:
          'It provides a clear view of all installed apps, like performance impact, storage usage and more.',
      },
    ],
  },
  {
    category: '🔋 Battery & Performance FAQs',
    items: [
      {
        question: '8. What does battery optimization do and will it improve battery performance?',
        answer:
          'It detects more power consuming apps and helps you to save battery life. Yes, it improves battery performance by reducing unnecessary background activity and increasing battery life.',
      },
    ],
  },
  {
    category: '🖼️ Photo Management FAQs',
    items: [
      {
        question: '10. How does the Photo Optimizer help?',
        answer:
          'Photo Optimizer detects duplicate, old, low-quality, and sensitive photos, letting you review and delete them easily to free up space.',
      },
    ],
  },
];

const GoCleanr = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Cleaner App FAQs</h1>
      <p className="mb-6">
        If you have any queries for our Cleaner app or face any difficulty using it, please write to us at{' '}
        <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 underline">
          feedback@appspacesolutions.in
        </a>.
      </p>
      {faqs.map((section, idx) => (
        <div key={idx} className="mb-8">
          <h2 className="text-xl font-semibold mb-3">{section.category}</h2>
          <ul className="space-y-4">
            {section.items.map((item, i) => (
              <li key={i}>
                <p className="font-bold">{item.question}</p>
                <div className="text-gray-700">{item.answer}</div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default GoCleanr;